module.exports = __webpack_public_path__ + "img/nhzt_fx.63438872.svg";